import { urls } from "../../../../urls";

export const v1EventLinkToV2 = (eventId: string, search: string): string => {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const question = params.get("question");
  const announcement = params.get("announcement");

  if (tab === "qa") {
    return question
      ? urls.v2.sourcingEvents.view.question(eventId, question)
      : `${urls.v2.sourcingEvents.view.go(eventId)}?tab=communication&sub=questions`;
  }
  if (tab === "announcements") {
    return announcement
      ? urls.v2.sourcingEvents.view.announcement(eventId, announcement)
      : `${urls.v2.sourcingEvents.view.go(eventId)}?tab=communication&sub=information`;
  }
  return urls.v2.sourcingEvents.view.go(eventId);
};
